// The one law for what a signed-in person is CALLED on the Desk (US-CAN-08,
// principal's word 2026-09-10: the account chip showed the sign-in email;
// it should show the person's name, which the Actor row holds).
//
// Order: the names the person typed on their profile (first + last), then
// the displayName provisioning minted from the identity provider at first
// sign-in, then the sign-in email itself — never a blank, never "Account".
// The email stays the identity precondition everywhere else; here it is
// the last resort, not the face.

export interface AccountNameSource {
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly displayName: string | null;
}

function trimmed(value: string | null | undefined): string {
  return value?.trim() ?? "";
}

export function accountDisplayName(
  profile: AccountNameSource | null | undefined,
  identity: string | null,
): string | null {
  const personName = [trimmed(profile?.firstName), trimmed(profile?.lastName)]
    .filter((part) => part.length > 0)
    .join(" ");
  if (personName.length > 0) return personName;
  const displayName = trimmed(profile?.displayName);
  if (displayName.length > 0) return displayName;
  return identity;
}

/**
 * The secondary line beside a name: the sign-in email when it is not
 * already the name being shown, else nothing (never the same string twice).
 */
export function accountIdentityAside(name: string | null, identity: string | null): string | null {
  if (identity === null || identity.trim().length === 0) return null;
  return name === identity ? null : identity;
}
